import { FC } from 'react'
import IconImage from '@/assets/img/icons/trafficJam3.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={IconImage}
      alt='trafficJam3'
      width={width}
      height={height}
    />
  )
}

export default Icon
